import { FormIdentifierService as OvermapFormIdentifierService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormIdentifierService extends OvermapFormIdentifierService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
